import React from "react";
import { useTranslation } from "react-i18next";

const Technology: React.FC = () => {
  const { t } = useTranslation();
  const features = [
    {
      img: "/sustain4.webp",
      titleKey: "technology_feature_1_title",
      descKey: "technology_feature_1_desc",
    },
    {
      img: "/sustain2.webp",
      titleKey: "technology_feature_2_title",
      descKey: "technology_feature_2_desc",
    },
  ];

  // Only render if features length is 2 or less
  if (features.length > 2) return null;

  return (
    <section className="bg-white py-14">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-12 justify-center items-start">

          {features.map((feature, index) => (
            <div
              key={index}
              className="flex-1 bg-white rounded-3xl shadow-lg overflow-hidden flex flex-col items-center"
            >
              {feature.img && (
                <img
                  src={feature.img}
                  alt={t(feature.titleKey)}
                  className="w-full h-72 object-cover rounded-t-3xl shadow-xl"
                />
              )}
              <div className="p-6 text-center">
                <h4 className="font-bold text-[#002f37] text-2xl mb-4">
                  {t(feature.titleKey)}
                </h4>
                <p className="text-[#002f37] text-base">
                  {t(feature.descKey)}
                </p>
              </div>
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default Technology;
